import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/apply/system/settings',
    name: 'SystemSettings',
    component: () => import('@/views/apply/system/settings'),
    meta: {
      title: i18n.t('router.system.system_settings'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/system/paymentSettings',
    name: 'PaymentSettings',
    component: () => import('@/views/apply/system/payment_settings'),
    meta: {
      title: i18n.t('router.system.payment_settings'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/system/smsSettings',
    name: 'ApplySystemSmsSettings',
    component: () => import('@/views/apply/system/sms_settings'),
    meta: {
      title: i18n.t('router.system.sms_settings'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/system/alarmSettings',
    name: 'ApplySystemAlarmSettings',
    component: () => import('@/views/apply/system/alarm_settings'),
    meta: {
      title: i18n.t('router.system.alarm_settings'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/system/customerServiceSettings',
    name: 'CustomerServiceSettings',
    component: () => import('@/views/apply/system/customer_service_settings'),
    meta: {
      title: i18n.t('router.system.customer_service_settings'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/system/shopSettings',
    name: 'ShopSettings',
    component: () => import('@/views/apply/system/shop_settings'),
    meta: {
      title: i18n.t('router.system.shop_settings'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/system/power',
    name: 'Power',
    component: () => import('@/views/apply/system/power'),
    meta: {
      title: i18n.t('router.system.permission_manage'),
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/system.js